import types from './types';

const getAssetEquipmentAutocompleteList = prefixStr => ({
  type: types.GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST,
  params: { prefixStr: prefixStr.replace(/\\/g, '') },
});

const getPositionEquipmentAutocompleteList = prefixStr => ({
  type: types.GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST,
  params: { prefixStr: prefixStr.replace(/\\/g, '') },
});

const getEquipmentLevAutocompleteList = prefixStr => ({
  type: types.GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST,
  params: { prefixStr: prefixStr.replace(/\\/g, '') },
});

export default {
  getAssetEquipmentAutocompleteList,
  getPositionEquipmentAutocompleteList,
  getEquipmentLevAutocompleteList,
};
